import { ValueGetterParams } from 'ag-grid-community'
import { Negotiation, NegotiationFieldMeta, NestedLegItem } from 'api'
import { getNegotiatedValue } from 'model'
import { getNegotiationDetailFromAgGridContext } from '../datagrid'

const preAssignmentRowDataGetter = (params: ValueGetterParams<NestedLegItem>) => {
  return params.data
}

export const makeValueGetter = (fieldName: keyof typeof NegotiationFieldMeta) => (params: ValueGetterParams<NestedLegItem>) => {
  const data = preAssignmentRowDataGetter(params)

  const negotiableFieldRequired = data?.negotiationFields?.[fieldName]?.negotiableFieldRequired

  if (!negotiableFieldRequired) {
    return null
  } else {
    return getNegotiatedValue(negotiableFieldRequired)
  }
}

export interface DetailGridNegotiableCellRendererProps<T> {
  data: T | undefined
  ownOrder: boolean
  negotiation: Negotiation
}

export const detailGridNegotiableCellRendererRowDataGetter = <T>(
  params: ValueGetterParams<T>
): DetailGridNegotiableCellRendererProps<T> => {
  const negotiationDetail = getNegotiationDetailFromAgGridContext(params)

  return {
    data: params.data,
    ownOrder: negotiationDetail.ownOrder,
    negotiation: negotiationDetail.negotiation
  }
}
